import { createPinia, defineStore } from "pinia";
import swal from "sweetalert";
export const useCartStore = defineStore("cart", {
  state: () => ({
    cartItems: [],
    couponCodeData: {
      codeApplied: false,
      id: null,
      discount_value: null,
      discount_type: null,
      discountCode: null,
      type: null,
      buy_quantity: null,
      get_quantity: null,
      eligible_product_ids: null,
      freeItemsAdded: 0, // Track total free items added to cart
      disableQuantityDiscount: false, // Flag to disable quantity discount when BUY2GET1 is better
    },
    shippingRate: 0,
    tax: {
      isTax: false,
      state_id: null,
      tax_value: null,
    },
    allProducts: [],
  }),
  persist: true,
  getters: {
    countCartItems: (state) => state.cartItems.length,
    getCartItems: (state) => state.cartItems,
    getCartCoupon: (state) => state.couponCodeData.codeApplied,
    getCartCouponCode: (state) => state.couponCodeData.discountCode,
    getCartCouponCodeId: (state) => state.couponCodeData.id,
    getCartCountQuantity: (state) => {
      let i = 0;
      let totalQty = 0;
      let cartAll = state.cartItems;
      for (i = 0; i < state.cartItems.length; i++) {
        totalQty += state.cartItems[i].quantity;
      }
      return totalQty;
    },
    getCartPurchaseType: (state) => {
      let i = 0;
      let totalQty = 0;
      let cartAll = state.cartItems;
      for (i = 0; i < state.cartItems.length; i++) {
        if(state.cartItems[i].purchaseType == 2){
          return true;
        }
      }
      return false;

      
    },
    getCartTotalPrice: (state) => {
      let i = 0;
      let totalPrice = 0;
      let cartAll = state.cartItems;
      for (i = 0; i < state.cartItems.length; i++) {
        totalPrice += state.cartItems[i].quantity * state.cartItems[i].price;
      }
      (totalPrice * state.tax.tax_value) / 100;
      return (
        parseFloat(totalPrice) 
        //+
        //parseFloat((totalPrice * state.tax.tax_value) / 100) +
       // parseFloat(state.shippingRate)
      ).toFixed(2);
    },

    getDiscountTotal: (state) => {
      let i = 0;
      let totalPrice = 0;
      let cartAll = state.cartItems;
      for (i = 0; i < state.cartItems.length; i++) {
        if (state.couponCodeData.codeApplied) {
          totalPrice += state.cartItems[i].quantity * state.cartItems[i].sale_price;
        }
        else{
          totalPrice += state.cartItems[i].quantity * state.cartItems[i].price;
        }

      }
      if (state.couponCodeData.codeApplied) {
        // Handle Buy X Get Y Free discount
        if (state.couponCodeData.discount_type == "buy_x_get_y") {
          const freeItemsAdded = state.couponCodeData.freeItemsAdded || 0;
          const eligibleProductIds = state.couponCodeData.eligible_product_ids;

          if (freeItemsAdded > 0) {
            let totalQuantity = 0;
            let eligibleTotalPrice = 0;

            // Calculate total price of eligible items using ORIGINAL price
            if (eligibleProductIds && eligibleProductIds.length > 0) {
              for (i = 0; i < state.cartItems.length; i++) {
                if (eligibleProductIds.includes(String(state.cartItems[i].id))) {
                  // Find original price from allProducts
                  const productIndex = state.allProducts.findIndex(p => p.id === state.cartItems[i].id);
                  const originalPrice = productIndex !== -1 ? parseFloat(state.allProducts[productIndex].price) : parseFloat(state.cartItems[i].price);

                  totalQuantity += state.cartItems[i].quantity;
                  eligibleTotalPrice += state.cartItems[i].quantity * originalPrice;
                }
              }
            } else {
              // No product restriction, count all items using ORIGINAL prices
              for (i = 0; i < state.cartItems.length; i++) {
                // Find original price from allProducts
                const productIndex = state.allProducts.findIndex(p => p.id === state.cartItems[i].id);
                const originalPrice = productIndex !== -1 ? parseFloat(state.allProducts[productIndex].price) : parseFloat(state.cartItems[i].price);

                totalQuantity += state.cartItems[i].quantity;
                eligibleTotalPrice += state.cartItems[i].quantity * originalPrice;
              }
            }

            // Calculate average price per item (includes both paid and free items)
            const avgPricePerItem = totalQuantity > 0 ? eligibleTotalPrice / totalQuantity : 0;

            // Discount is the value of free items that were auto-added
            return (freeItemsAdded * avgPricePerItem).toFixed(2);
          }
          return 0;
        } else if (
          state.couponCodeData.discount_type == "percentage" &&
          state.couponCodeData.type == "product"
        ) {
          return (
            (totalPrice * state.couponCodeData.discount_value) /
            100
          ).toFixed(2);
        } else if (
          state.couponCodeData.discount_type == "percentage" &&
          state.couponCodeData.type == "shipping"
        ) {
          return (
            (state.shippingRate * state.couponCodeData.discount_value) /
            100
          ).toFixed(2);
        } else {
          return (
            totalPrice.toFixed(2) - state.couponCodeData.discount_value
          ).toFixed(2);
        }
      } else {
        return 0;
      }
    },

    getTaxTotal: (state) => {
      let i = 0;
      let totalPrice = 0;
      let productTotalDiscount = 0;
      let cartAll = state.cartItems;

      // Calculate total price
      for (i = 0; i < state.cartItems.length; i++) {
        totalPrice += state.cartItems[i].quantity * state.cartItems[i].price;
      }

      // Calculate discount if coupon is applied
      if (state.couponCodeData.codeApplied) {
        if (state.couponCodeData.discount_type == "buy_x_get_y") {
          // Calculate buy_x_get_y discount
          const freeItemsAdded = state.couponCodeData.freeItemsAdded || 0;
          const eligibleProductIds = state.couponCodeData.eligible_product_ids;

          if (freeItemsAdded > 0) {
            let totalQuantity = 0;
            let eligibleTotalPrice = 0;

            // Calculate total price of eligible items
            if (eligibleProductIds && eligibleProductIds.length > 0) {
              for (let j = 0; j < state.cartItems.length; j++) {
                if (eligibleProductIds.includes(String(state.cartItems[j].id))) {
                  totalQuantity += state.cartItems[j].quantity;
                  eligibleTotalPrice += state.cartItems[j].quantity * state.cartItems[j].price;
                }
              }
            } else {
              // No product restriction, count all items
              totalQuantity = 0;
              for (let j = 0; j < state.cartItems.length; j++) {
                totalQuantity += state.cartItems[j].quantity;
              }
              eligibleTotalPrice = totalPrice;
            }

            // Calculate average price per item (includes both paid and free items)
            const avgPricePerItem = totalQuantity > 0 ? eligibleTotalPrice / totalQuantity : 0;

            // Discount is the value of free items that were auto-added
            productTotalDiscount = parseFloat((freeItemsAdded * avgPricePerItem).toFixed(2));
          }
        } else if (
          state.couponCodeData.discount_type == "percentage" &&
          state.couponCodeData.type == "product"
        ) {
          productTotalDiscount = parseFloat((totalPrice * state.couponCodeData.discount_value) / 100);
        } else if (
          state.couponCodeData.discount_type == "value" &&
          state.couponCodeData.type == "product"
        ) {
          productTotalDiscount = state.couponCodeData.discount_value;
        }
      }

      // Subtract discount from total price before calculating tax
      const priceAfterDiscount = totalPrice - productTotalDiscount;

      // Apply tax on the discounted amount
      if (state.tax.isTax) {
        return ((priceAfterDiscount * state.tax.tax_value) / 100).toFixed(2);
      } else {
        return 0;
      }
    },

    getCartTotalNetPrice: (state) => {
      let i = 0;
      let totalPrice = 0;
      let shippingDiscount = 0;
      let productTotalDiscount = 0;
      let cartAll = state.cartItems;
      for (i = 0; i < state.cartItems.length; i++) {
        if (state.couponCodeData.codeApplied) {
          totalPrice += state.cartItems[i].quantity * state.cartItems[i].price;
        }
        else{
          totalPrice += state.cartItems[i].quantity * state.cartItems[i].price;
        }
        
      }

      let totalTax = 0;

      if (state.tax.isTax) {
        totalTax = parseFloat((totalPrice * state.tax.tax_value) / 100).toFixed(
          2
        );
      }

      if (state.couponCodeData.codeApplied) {
        if (
          state.couponCodeData.discount_type == "buy_x_get_y"
        ) {
          // Calculate buy_x_get_y discount
          const freeItemsAdded = state.couponCodeData.freeItemsAdded || 0;
          const eligibleProductIds = state.couponCodeData.eligible_product_ids;

          if (freeItemsAdded > 0) {
            let totalQuantity = 0;
            let eligibleTotalPrice = 0;

            // Calculate total price of eligible items
            if (eligibleProductIds && eligibleProductIds.length > 0) {
              for (let j = 0; j < state.cartItems.length; j++) {
                if (eligibleProductIds.includes(String(state.cartItems[j].id))) {
                  totalQuantity += state.cartItems[j].quantity;
                  eligibleTotalPrice += state.cartItems[j].quantity * state.cartItems[j].price;
                }
              }
            } else {
              // No product restriction, count all items
              totalQuantity = 0;
              for (let j = 0; j < state.cartItems.length; j++) {
                totalQuantity += state.cartItems[j].quantity;
              }
              eligibleTotalPrice = totalPrice;
            }

            // Calculate average price per item (includes both paid and free items)
            const avgPricePerItem = totalQuantity > 0 ? eligibleTotalPrice / totalQuantity : 0;

            // Discount is the value of free items that were auto-added
            productTotalDiscount = parseFloat((freeItemsAdded * avgPricePerItem).toFixed(2));
            totalPrice = parseFloat(totalPrice) - parseFloat(productTotalDiscount);
            totalPrice = parseFloat(totalPrice).toFixed(2);
          }
        } else if (
          state.couponCodeData.discount_type == "percentage" &&
          state.couponCodeData.type == "shipping"
        ) {
          console.log("check shippingRate data :");
          shippingDiscount =
            (state.shippingRate) * (state.couponCodeData.discount_value / 100);
          console.log("check shippingRate data : ", shippingDiscount);
          //state.shippingRate = state.shippingRate - shippingDiscount;
        } else if (
          state.couponCodeData.discount_type == "percentage" &&
          state.couponCodeData.type == "product"
        ) {
          productTotalDiscount = parseFloat((totalPrice * state.couponCodeData.discount_value) / 100);
          totalPrice = parseFloat(totalPrice) - parseFloat(productTotalDiscount);
          totalPrice = parseFloat(totalPrice).toFixed(2);
        } else if (
          state.couponCodeData.discount_type == "value" &&
          state.couponCodeData.type == "product"
        ) {
          totalPrice = parseFloat(totalPrice) - state.couponCodeData;
        } else if (
          state.couponCodeData.discount_type == "value" &&
          state.couponCodeData.type == "shipping"
        ) {
          shippingDiscount = state.couponCodeData.discount_value;
          //state.shippingRate = state.shippingRate - shippingDiscount;
        } else {
          //console.log("coupn net else:");
          //return state.shippingRate;
        }
      }
      console.log("state.couponCodeData.discount_value", state.couponCodeData.discount_value);
      console.log("productTotalDiscount : ", productTotalDiscount); 
      console.log("totalPrice : ", totalPrice);
      console.log("state.shippingRate  : ", state.shippingRate);
      console.log("shippingDiscount : ", shippingDiscount);
      console.log("totalTax : ", totalTax);

      let shippingTax = 0;
       if (state.tax.isTax){
        shippingTax =  ((state.shippingRate * state.tax.tax_value) / 100).toFixed(2);
      } else {
        shippingTax = 0;
      }

      return (
        parseFloat(totalPrice) +
        parseFloat(state.shippingRate - shippingDiscount) +
        parseFloat(totalTax) +
        parseFloat(shippingTax)
      ).toFixed(2);
      // else {
      //   console.log("net else:");
      //   return state.shippingRate;
      // }
    },
    getCandaSates: (state) => state.canadaStates,
    getUnitedStates: (state) => state.unitedStates,
    getShippingRate: (state) => {
      let shippingDiscount = 0;
      if (state.couponCodeData.codeApplied) {
        if (
          state.couponCodeData.discount_type == "percentage" &&
          state.couponCodeData.type == "shipping"
        ) {
          return state.shippingRate;

          // return (
          //   state.shippingRate -
          //   (state.shippingRate * state.couponCodeData.discount_value) / 100
          // ).toFixed(2);
        } else {
          return state.shippingRate;
        }
      } else {
        return state.shippingRate;
      }
    },
    getShippingTax: (state) => {


       if (state.tax.isTax) {
        return ((state.shippingRate * state.tax.tax_value) / 100).toFixed(2);
      } else {
        return 0;
      }


      // let shippingDiscount = 0;
      // if (state.couponCodeData.codeApplied) {
      //   if (
      //     state.couponCodeData.discount_type == "percentage" &&
      //     state.couponCodeData.type == "shipping"
      //   ) {

         

      //     return state.shippingRate;

      //     // return (
      //     //   state.shippingRate -
      //     //   (state.shippingRate * state.couponCodeData.discount_value) / 100
      //     // ).toFixed(2);
      //   } else {
      //   }
      // } else {
      //   return state.shippingRate;
      // }
    },
    getShippingDiscount: (state) => {
      let shippingDiscount = 0;
      if (state.couponCodeData.codeApplied) {
        if (
          state.couponCodeData.discount_type == "percentage" &&
          state.couponCodeData.type == "shipping"
        ) {
          return (
            (state.shippingRate * state.couponCodeData.discount_value) /
            100
          ).toFixed(2);
        } else {
        }
      } else {
        return shippingDiscount;
      }
    },
    getBuyXGetYInfo: (state) => {
      if (state.couponCodeData.codeApplied && state.couponCodeData.discount_type == "buy_x_get_y") {
        const buyQty = state.couponCodeData.buy_quantity;
        const getQty = state.couponCodeData.get_quantity;
        const eligibleProductIds = state.couponCodeData.eligible_product_ids;

        if (buyQty && getQty) {
          let totalQuantity = 0;

          // If product_ids is specified, only count eligible products
          if (eligibleProductIds && eligibleProductIds.length > 0) {
            for (let i = 0; i < state.cartItems.length; i++) {
              if (eligibleProductIds.includes(String(state.cartItems[i].id))) {
                totalQuantity += state.cartItems[i].quantity;
              }
            }
          } else {
            // No product restriction, count all items
            for (let i = 0; i < state.cartItems.length; i++) {
              totalQuantity += state.cartItems[i].quantity;
            }
          }

          // Calculate how many complete sets (buy + get) the user has
          const setSize = buyQty + getQty;
          const completeSets = Math.floor(totalQuantity / setSize);
          const freeItems = completeSets * getQty;

          return {
            isActive: true,
            buyQuantity: buyQty,
            getQuantity: getQty,
            totalQuantity: totalQuantity,
            freeItems: freeItems,
            message: `Buy ${buyQty} Get ${getQty} Free Applied`
          };
        }
      }

      return {
        isActive: false,
        buyQuantity: 0,
        getQuantity: 0,
        totalQuantity: 0,
        freeItems: 0,
        message: ''
      };
    },
    hasQuantityDiscountActive: (state) => {
      // Check if any product in cart has quantity discount applied
      // Quantity discount applies when: purchaseType != 2 AND quantity qualifies for qty_range
      for (let i = 0; i < state.cartItems.length; i++) {
        const item = state.cartItems[i];

        // Skip autoship products (purchaseType 2)
        if (item.purchaseType == 2) {
          continue;
        }

        // Find product in allProducts to check qty_range
        const productIndex = state.allProducts.findIndex(p => p.id === item.id);
        if (productIndex === -1) {
          continue;
        }

        const product = state.allProducts[productIndex];
        const quantity = item.quantity;

        // Check if quantity qualifies for any range discount
        // Range 1
        const range1 = product.cust_qty_range_1?.replace("+", "").split("-") || [];
        if (range1.length > 0) {
          const min = parseInt(range1[0]);
          const max = range1.length === 2 ? parseInt(range1[1]) : Infinity;
          if (quantity >= min && quantity <= max && product.cust_qty_range_1_per > 0) {
            return true;
          }
        }

        // Range 2
        const range2 = product.cust_qty_range_2?.replace("+", "").split("-") || [];
        if (range2.length > 0) {
          const min = parseInt(range2[0]);
          const max = range2.length === 2 ? parseInt(range2[1]) : Infinity;
          if (quantity >= min && quantity <= max && product.cust_qty_range_2_per > 0) {
            return true;
          }
        }

        // Range 3
        const range3 = product.cust_qty_range_3?.replace("+", "").split("-") || [];
        if (range3.length > 0) {
          const min = parseInt(range3[0]);
          const max = range3.length === 2 ? parseInt(range3[1]) : Infinity;
          if (quantity >= min && quantity <= max && product.cust_qty_range_3_per > 0) {
            return true;
          }
        }
      }

      return false;
    },

    // Calculate total quantity discount amount (on original price)
    getQuantityDiscountAmount: (state) => {
      // If BUY2GET1 coupon is applied and won the comparison, don't apply quantity discount
      if (state.couponCodeData.disableQuantityDiscount) {
        return 0;
      }

      let totalDiscount = 0;

      for (let i = 0; i < state.cartItems.length; i++) {
        const item = state.cartItems[i];

        // Skip autoship products (purchaseType 2)
        if (item.purchaseType == 2) {
          continue;
        }

        // Find product in allProducts to get original price and qty_range
        const productIndex = state.allProducts.findIndex(p => p.id === item.id);
        if (productIndex === -1) {
          continue;
        }

        const product = state.allProducts[productIndex];
        const quantity = item.quantity;
        const originalPrice = parseFloat(product.price); // Original price before any discount
        let discountPercentage = 0;

        // Check which range applies and get discount percentage
        // Range 1
        const range1 = product.cust_qty_range_1?.replace("+", "").split("-") || [];
        if (range1.length > 0) {
          const min = parseInt(range1[0]);
          const max = range1.length === 2 ? parseInt(range1[1]) : Infinity;
          if (quantity >= min && quantity <= max && product.cust_qty_range_1_per > 0) {
            discountPercentage = parseFloat(product.cust_qty_range_1_per);
          }
        }

        // Range 2
        const range2 = product.cust_qty_range_2?.replace("+", "").split("-") || [];
        if (range2.length > 0) {
          const min = parseInt(range2[0]);
          const max = range2.length === 2 ? parseInt(range2[1]) : Infinity;
          if (quantity >= min && quantity <= max && product.cust_qty_range_2_per > 0) {
            discountPercentage = parseFloat(product.cust_qty_range_2_per);
          }
        }

        // Range 3
        const range3 = product.cust_qty_range_3?.replace("+", "").split("-") || [];
        if (range3.length > 0) {
          const min = parseInt(range3[0]);
          const max = range3.length === 2 ? parseInt(range3[1]) : Infinity;
          if (quantity >= min && quantity <= max && product.cust_qty_range_3_per > 0) {
            discountPercentage = parseFloat(product.cust_qty_range_3_per);
          }
        }

        // Calculate discount on ORIGINAL price
        if (discountPercentage > 0) {
          const itemDiscount = (originalPrice * quantity * discountPercentage) / 100;
          totalDiscount += itemDiscount;
        }
      }

      return totalDiscount;
    },

    // Calculate BUY X GET Y discount amount (on original price)
    calculateBuyXGetYDiscount: (state) => (buyQty, getQty, eligibleProductIds) => {
      let totalFreeItems = 0;
      let totalDiscount = 0;

      for (let i = 0; i < state.cartItems.length; i++) {
        const item = state.cartItems[i];

        // Check if item is eligible
        const isEligible = !eligibleProductIds || eligibleProductIds.length === 0 ||
                          eligibleProductIds.includes(String(item.id));

        if (isEligible && item.quantity === buyQty) {
          // Find product to get ORIGINAL price
          const productIndex = state.allProducts.findIndex(p => p.id === item.id);
          if (productIndex !== -1) {
            const product = state.allProducts[productIndex];
            const originalPrice = parseFloat(product.price);

            // Discount = free items × original price
            totalFreeItems += getQty;
            totalDiscount += (getQty * originalPrice);
          }
        }
      }

      return {
        totalFreeItems,
        totalDiscount
      };
    },
  },
  actions: {
    addAllProducts(productSingle) {
      let index = this.allProducts.findIndex(
        (product) => product.id === productSingle.id
      );
      if (index > -1) {
        this.allProducts.splice(index, 1);
        
      }
      this.allProducts.push(productSingle);
    },
    addTaxData(taxData) {
      this.tax.isTax = true;
      this.tax.state_id = taxData.state_id;
      this.tax.tax_value = taxData.tax_value;
    },
    clearTax() {
      this.tax.isTax = false;
      this.tax.state_id = null;
      this.tax.tax_value = null;
    },
    // Validate if buy_x_get_y coupon can be applied
    validateBuyXGetY(coupon) {
      if (coupon.discount_type !== 'buy_x_get_y' || !coupon.buy_quantity) {
        return { valid: true };
      }

      const buyQty = coupon.buy_quantity;
      const getQty = coupon.get_quantity || 0;
      const eligibleProductIds = coupon.eligible_product_ids;

      // Check each eligible item - quantity must be <= buy_quantity
      for (let i = 0; i < this.cartItems.length; i++) {
        const item = this.cartItems[i];

        const isEligible = !eligibleProductIds || eligibleProductIds.length === 0 ||
                          eligibleProductIds.includes(String(item.id));

        if (isEligible && item.quantity > buyQty) {
          return {
            valid: false,
            message: `This Buy ${buyQty} Get ${getQty} Free coupon only works when you have exactly ${buyQty} item${buyQty > 1 ? 's' : ''}. You currently have ${item.quantity} item${item.quantity > 1 ? 's' : ''}.`
          };
        }
      }

      return { valid: true };
    },

    applyCoupon(coupon, discountCode) {
      // Compare discounts if this is a buy_x_get_y coupon and quantity discount exists
      if (coupon.discount_type === 'buy_x_get_y' && coupon.buy_quantity && coupon.get_quantity) {
        const buyQty = coupon.buy_quantity;
        const getQty = coupon.get_quantity;
        const eligibleProductIds = coupon.eligible_product_ids;

        // Calculate BUY X GET Y discount (on original price)
        const buyXGetYResult = this.calculateBuyXGetYDiscount(buyQty, getQty, eligibleProductIds);
        const buyXGetYDiscount = buyXGetYResult.totalDiscount;

        // Calculate quantity discount (on original price)
        const quantityDiscount = this.getQuantityDiscountAmount;

        console.log('💰 Discount Comparison:', {
          buyXGetYDiscount,
          quantityDiscount,
          winner: buyXGetYDiscount > quantityDiscount ? 'BUY X GET Y' : 'Quantity Discount'
        });

        // If quantity discount is better or equal, don't apply the coupon
        if (quantityDiscount >= buyXGetYDiscount && quantityDiscount > 0) {
          // Return info to show user
          return {
            applied: false,
            reason: 'quantity_discount_better',
            quantityDiscount: quantityDiscount.toFixed(2),
            buyXGetYDiscount: buyXGetYDiscount.toFixed(2),
            message: `Your current quantity discount ($${quantityDiscount.toFixed(2)}) is better than the Buy ${buyQty} Get ${getQty} Free coupon ($${buyXGetYDiscount.toFixed(2)}). Keeping quantity discount.`
          };
        }
      }

      // Apply the coupon
      this.couponCodeData.codeApplied = true;
      this.couponCodeData.id = coupon.id;
      this.couponCodeData.discount_value = coupon.discount_value;
      this.couponCodeData.discount_type = coupon.discount_type;
      this.couponCodeData.discountCode = discountCode;
      this.couponCodeData.type = coupon.type;
      this.couponCodeData.buy_quantity = coupon.buy_quantity || null;
      this.couponCodeData.get_quantity = coupon.get_quantity || null;
      this.couponCodeData.eligible_product_ids = coupon.eligible_product_ids || null;
      this.couponCodeData.disableQuantityDiscount = (coupon.discount_type === 'buy_x_get_y'); // Disable quantity discount when BUY2GET1 is applied

      // Auto-add free items for buy_x_get_y discounts
      if (coupon.discount_type === 'buy_x_get_y' && coupon.buy_quantity && coupon.get_quantity) {
        const buyQty = coupon.buy_quantity;
        const getQty = coupon.get_quantity;
        const eligibleProductIds = coupon.eligible_product_ids;

        let totalFreeItems = 0;

        // Calculate and add free items to cart
        for (let i = 0; i < this.cartItems.length; i++) {
          const item = this.cartItems[i];

          // Check if item is eligible (if product_ids restriction exists)
          const isEligible = !eligibleProductIds || eligibleProductIds.length === 0 ||
                            eligibleProductIds.includes(String(item.id));

          if (isEligible) {
            // Only apply if quantity is exactly buy_quantity (validation should catch this)
            if (item.quantity === buyQty) {
              const freeItems = getQty;

              // Add free items to cart quantity
              this.cartItems[i].quantity += freeItems;
              totalFreeItems += freeItems;
            }
          }
        }

        this.couponCodeData.freeItemsAdded = totalFreeItems;
      }

      // Return success
      return {
        applied: true,
        message: 'Coupon applied successfully'
      };
    },
    resetApplyCoupon() {
      // Remove auto-added free items for buy_x_get_y discounts
      if (this.couponCodeData.discount_type === 'buy_x_get_y' &&
          this.couponCodeData.buy_quantity &&
          this.couponCodeData.get_quantity &&
          this.couponCodeData.freeItemsAdded > 0) {
        const buyQty = this.couponCodeData.buy_quantity;
        const getQty = this.couponCodeData.get_quantity;
        const eligibleProductIds = this.couponCodeData.eligible_product_ids;

        // Remove free items from cart using the exact amount we added
        for (let i = 0; i < this.cartItems.length; i++) {
          const item = this.cartItems[i];

          // Check if item is eligible (if product_ids restriction exists)
          const isEligible = !eligibleProductIds || eligibleProductIds.length === 0 ||
                            eligibleProductIds.includes(String(item.id));

          if (isEligible && item.quantity === (buyQty + getQty)) {
            // Remove the free items that were added
            this.cartItems[i].quantity = buyQty;
          }
        }
      }

      // Reset all coupon data
      this.couponCodeData.codeApplied = false;
      this.couponCodeData.id = null;
      this.couponCodeData.discount_value = null;
      this.couponCodeData.discount_type = null;
      this.couponCodeData.discountCode = null;
      this.couponCodeData.type = null;
      this.couponCodeData.buy_quantity = null;
      this.couponCodeData.get_quantity = null;
      this.couponCodeData.eligible_product_ids = null;
      this.couponCodeData.freeItemsAdded = 0;
      this.couponCodeData.disableQuantityDiscount = false;
    },
    addShippingRate(rate) {
      this.shippingRate = rate;
    },
    emptyShippingRate() {
      this.shippingRate = 0;
    },
    checkRangeFun(rangeData, quantity) {
      let checkFlag = false;
      if (rangeData.length == 2) {
        if (
          quantity >= parseInt(rangeData[0]) &&
          quantity <= parseInt(rangeData[1])
        ) {
          checkFlag = true;
        }
        // for (var i = parseInt(rangeData[0]); i <= parseInt(rangeData[1]); i++) {
        //   if (i == quantity) {
        //     console.log("quantity chec ", i);
        //     checkFlag = true;
        //   }
        // }
      } else if (rangeData.length == 1) {
        if (quantity >= parseInt(rangeData[0])) {
          checkFlag = true;
        }
      } else {
        console.log("jjjjjjjjjjjjjj");
      }

      return checkFlag;
    },
    addToCart(item) {
      let index = this.cartItems.findIndex((product) => product.id === item.id);
      if (index !== -1) {
        console.log("here", item);
        //this.products[index].quantity += 1;
        this.cartItems[index].price = item.price;
        this.cartItems[index].quantity += item.quantity;
        this.cartItems[index].purchaseType = item.purchaseType;
        this.cartItems[index].sale_price = item.sale_price;

        console.log("nee ", this.cartItems);
        //   swal({
        //         position: 'top-end',
        //         text: "Your item has been updated",
        //         icon: "success",
        //         closeOnClickOutside: false,
        //     });
      } else {
        console.log("thhhhere", item);
        // item.quantity = 1;
        this.cartItems.push(item);
        // swal({
        //     position: 'top-end',
        //     text: "Your item has been saved",
        //     icon: "success",
        //     closeOnClickOutside: false,
        // });
      }
    },
    incrementQ(item, checkIsLoggedIn, getUserUserData) {

      
      let index = this.cartItems.findIndex((product) => product.id === item.id);
      if (index !== -1) {
        let productListIindex = this.allProducts.findIndex(
          (productSingle) => productSingle.id === item.id
        );

        this.cartItems[index].quantity += 1;

        let range1 = [];
        let range2 = [];
        let range3 = [];
        let totalQuantity = this.cartItems[index].quantity;
        let productPrice = 0;
        //if (index !== -1) {
        range1 = this.allProducts[productListIindex].qty_range_1
          .replace("+", "")
          .split("-");
        range2 = this.allProducts[productListIindex].qty_range_2
          .replace("+", "")
          .split("-");
        range3 = this.allProducts[productListIindex].qty_range_3
          .replace("+", "")
          .split("-");
        //totalQuantity += 1;
        //}

        let rangeWhich1 = this.checkRangeFun(range1, totalQuantity);
        let rangeWhich2 = this.checkRangeFun(range2, totalQuantity);
        let rangeWhich3 = this.checkRangeFun(range3, totalQuantity);

        // Customer Range
        let customerRange1 = this.allProducts[
          productListIindex
        ].cust_qty_range_1
          .replace("+", "")
          .split("-");
        let customerRange2 = this.allProducts[
          productListIindex
        ].cust_qty_range_2
          .replace("+", "")
          .split("-");
        let customerRange3 = this.allProducts[
          productListIindex
        ].cust_qty_range_3
          .replace("+", "")
          .split("-");
        // Customer Range Ends Here
        let customerRangeWhich1 = this.checkRangeFun(
          customerRange1,
          totalQuantity
        );
        let customerRangeWhich2 = this.checkRangeFun(
          customerRange2,
          totalQuantity
        );
        let customerRangeWhich3 = this.checkRangeFun(
          customerRange3,
          totalQuantity
        );
        console.log("rangeWhich1 ", rangeWhich1);
        console.log("rangeWhich2 ", rangeWhich2);
        console.log("rangeWhich3 ", rangeWhich3);

        if (checkIsLoggedIn) {

          
          if (getUserUserData.user_type == "ambassador") {
           
            if (this.cartItems[index].purchaseType == 1) {
              productPrice = this.allProducts[productListIindex].amb_sale_price;
            } else if (this.cartItems[index].purchaseType == 2) {
              productPrice =
                this.allProducts[productListIindex].autoship_price_amb;
            } else {
              productPrice = this.allProducts[productListIindex].amb_sale_price;
            }
            if (this.cartItems[index].purchaseType != 2 && this.couponCodeData.discount_type !== 'buy_x_get_y') {
              if (rangeWhich1) {
                if (this.allProducts[productListIindex].qty_range_1_per > 0) {
                  productPrice =
                    productPrice -
                    (productPrice *
                      this.allProducts[productListIindex].qty_range_1_per) /
                      100;
                }
              } else if (rangeWhich2) {
                if (this.allProducts[productListIindex].qty_range_2_per > 0) {
                  productPrice =
                    productPrice -
                    (productPrice *
                      this.allProducts[productListIindex].qty_range_2_per) /
                      100;
                }
              } else if (rangeWhich3) {
                if (this.allProducts[productListIindex].qty_range_3_per > 0) {
                  productPrice =
                    productPrice -
                    (productPrice *
                      this.allProducts[productListIindex].qty_range_3_per) /
                      100;
                }
              }
            }
          } else if (getUserUserData.user_type == "scholar") {

            console.log("indeside scholar",this.cartItems[index].purchaseType);
            if (this.cartItems[index].purchaseType == 1) {
              productPrice = this.allProducts[productListIindex].sc_sale_price;
            } else if (this.cartItems[index].purchaseType == 2) {
              productPrice =
                this.allProducts[productListIindex].autoship_price_sc;
            } else {
              productPrice = this.allProducts[productListIindex].sc_sale_price;
            }
            console.log("Single Product Price from cart",productPrice);
            if (this.cartItems[index].purchaseType != 2 && this.couponCodeData.discount_type !== 'buy_x_get_y') {
              if (rangeWhich1) {
                if (this.allProducts[productListIindex].qty_range_1_per > 0) {
                  productPrice =
                    productPrice -
                    (productPrice *
                      this.allProducts[productListIindex].qty_range_1_per) /
                      100;
                }
                console.log("Scholar Range1",this.allProducts[productListIindex].qty_range_1_per);
              } else if (rangeWhich2) {
                if (this.allProducts[productListIindex].qty_range_2_per > 0) {
                  productPrice =
                    productPrice -
                    (productPrice *
                      this.allProducts[productListIindex].qty_range_2_per) /
                      100;
                }
                console.log("Scholar Range2",this.allProducts[productListIindex].qty_range_2_per);
              } else if (rangeWhich3) {
                if (this.allProducts[productListIindex].qty_range_3_per > 0) {
                  productPrice =
                    productPrice -
                    (productPrice *
                      this.allProducts[productListIindex].qty_range_3_per) /
                      100;
                }
                console.log("Scholar Range3",this.allProducts[productListIindex].qty_range_3_per);
              }
            }

          } else {
            if (this.cartItems[index].purchaseType == 1) {
              productPrice = this.allProducts[productListIindex].sale_price;
            } else if (this.cartItems[index].purchaseType == 2) {
              productPrice =
                this.allProducts[productListIindex].autoship_price_customer;
            } else {
              productPrice = this.allProducts[productListIindex].sale_price;
            }
            console.log("increment price before discount ",productPrice)
            console.log("this.cartItems[index] ", this.cartItems[index])

            if (this.cartItems[index].purchaseType != 2 && this.couponCodeData.discount_type !== 'buy_x_get_y') {

            if (customerRangeWhich1) {
              if (this.allProducts[productListIindex].cust_qty_range_1_per > 0) {
                productPrice =
                  productPrice -
                  (productPrice *
                    this.allProducts[productListIindex].cust_qty_range_1_per) /
                    100;
              }
            } else if (customerRangeWhich2) {
              if (this.allProducts[productListIindex].cust_qty_range_2_per > 0) {
                productPrice =
                  productPrice -
                  (productPrice *
                    this.allProducts[productListIindex].cust_qty_range_2_per) /
                    100;
              }
            } else if (customerRangeWhich3) {
              if (this.allProducts[productListIindex].cust_qty_range_3_per > 0) {
                productPrice =
                  productPrice -
                  (productPrice *
                    this.allProducts[productListIindex].cust_qty_range_3_per) /
                    100;
              }
            }
          }

          }

          //let productImage = "";
          // if (productSingle.value.images_url.length > 0) {
          //   productImage = productSingle.value.images_url[0];
          // }
        } else {
          console.log("indehere else");
          if (this.cartItems[index].purchaseType == 1) {
            productPrice = this.allProducts[productListIindex].sale_price;
          } else if (this.cartItems[index].purchaseType == 2) {
            productPrice =
              this.allProducts[productListIindex].autoship_price_customer;
          } else {
            productPrice = this.allProducts[productListIindex].sale_price;
          }
          if (this.cartItems[index].purchaseType != 2 && this.couponCodeData.discount_type !== 'buy_x_get_y') {

            if (customerRangeWhich1) {
              if (this.allProducts[productListIindex].cust_qty_range_1_per > 0) {
                productPrice =
                  productPrice -
                  (productPrice *
                    this.allProducts[productListIindex].cust_qty_range_1_per) /
                    100;
              }
            } else if (customerRangeWhich2) {
              if (this.allProducts[productListIindex].cust_qty_range_2_per > 0) {
                productPrice =
                  productPrice -
                  (productPrice *
                    this.allProducts[productListIindex].cust_qty_range_2_per) /
                    100;
              }
            } else if (customerRangeWhich3) {
              if (this.allProducts[productListIindex].cust_qty_range_3_per > 0) {
                productPrice =
                  productPrice -
                  (productPrice *
                    this.allProducts[productListIindex].cust_qty_range_3_per) /
                    100;
              }
            }
          }
        }

        console.log("productPrice ", productPrice);
        this.cartItems[index].price = productPrice;
        // swal({
        //     position: 'top-end',
        //     icon: 'success',
        //     title: 'Your item has been updated',
        //     showConfirmButton: false,
        //     timer: 1500
        // });
      }
    },
    decrementQ(item, checkIsLoggedIn, getUserUserData) {
      let index = this.cartItems.findIndex((product) => product.id === item.id);
      if (index !== -1) {
        if (this.cartItems[index].quantity != 1) {
          this.cartItems[index].quantity -= 1;

          let productListIindex = this.allProducts.findIndex(
            (productSingle) => productSingle.id === item.id
          );

          //this.cartItems[index].quantity += 1;

          let range1 = [];
          let range2 = [];
          let range3 = [];
          let totalQuantity = this.cartItems[index].quantity;
          let productPrice = 0;
          //if (index !== -1) {
          range1 = this.allProducts[productListIindex].qty_range_1
            .replace("+", "")
            .split("-");
          range2 = this.allProducts[productListIindex].qty_range_2
            .replace("+", "")
            .split("-");
          range3 = this.allProducts[productListIindex].qty_range_3
            .replace("+", "")
            .split("-");
          //totalQuantity += 1;
          //}

          let rangeWhich1 = this.checkRangeFun(range1, totalQuantity);
          let rangeWhich2 = this.checkRangeFun(range2, totalQuantity);
          let rangeWhich3 = this.checkRangeFun(range3, totalQuantity);

          // Customer Range
          let customerRange1 = this.allProducts[
            productListIindex
          ].cust_qty_range_1
            .replace("+", "")
            .split("-");
          let customerRange2 = this.allProducts[
            productListIindex
          ].cust_qty_range_2
            .replace("+", "")
            .split("-");
          let customerRange3 = this.allProducts[
            productListIindex
          ].cust_qty_range_3
            .replace("+", "")
            .split("-");
          // Customer Range Ends Here
          let customerRangeWhich1 = this.checkRangeFun(
            customerRange1,
            totalQuantity
          );
          let customerRangeWhich2 = this.checkRangeFun(
            customerRange2,
            totalQuantity
          );
          let customerRangeWhich3 = this.checkRangeFun(
            customerRange3,
            totalQuantity
          );
          console.log("rangeWhich1 ", rangeWhich1);
          console.log("rangeWhich2 ", rangeWhich2);
          console.log("rangeWhich3 ", rangeWhich3);

          if (checkIsLoggedIn) {
            if (getUserUserData.user_type == "ambassador") {
              if (this.cartItems[index].purchaseType == 1) {
                productPrice =
                  this.allProducts[productListIindex].amb_sale_price;
              } else if (
                this.cartItems[index].purchaseType == 2
              ) {
                productPrice =
                  this.allProducts[productListIindex].autoship_price_amb;
              } else {
                productPrice =
                  this.allProducts[productListIindex].amb_sale_price;
              }
            if (this.cartItems[index].purchaseType != 2 && this.couponCodeData.discount_type !== 'buy_x_get_y') {
                if (rangeWhich1) {
                  if (this.allProducts[productListIindex].qty_range_1_per > 0) {
                    productPrice =
                      productPrice -
                      (productPrice *
                        this.allProducts[productListIindex].qty_range_1_per) /
                        100;
                  }
                } else if (rangeWhich2) {
                  if (this.allProducts[productListIindex].qty_range_2_per > 0) {
                    productPrice =
                      productPrice -
                      (productPrice *
                        this.allProducts[productListIindex].qty_range_2_per) /
                        100;
                  }
                } else if (rangeWhich3) {
                  if (this.allProducts[productListIindex].qty_range_3_per > 0) {
                    productPrice =
                      productPrice -
                      (productPrice *
                        this.allProducts[productListIindex].qty_range_3_per) /
                        100;
                  }
                }

              }
            } else if (getUserUserData.user_type == "scholar") {
              if (this.cartItems[index].purchaseType == 1) {
                productPrice =
                  this.allProducts[productListIindex].sc_sale_price;
              } else if (
                this.cartItems[index].purchaseType == 2
              ) {
                productPrice =
                  this.allProducts[productListIindex].autoship_price_sc;
              } else {
                productPrice =
                  this.allProducts[productListIindex].sc_sale_price;
              }
              if (this.cartItems[index].purchaseType != 2 && this.couponCodeData.discount_type !== 'buy_x_get_y') {
                  if (rangeWhich1) {
                  if (this.allProducts[productListIindex].qty_range_1_per > 0) {
                    productPrice =
                      productPrice -
                      (productPrice *
                        this.allProducts[productListIindex].qty_range_1_per) /
                        100;
                  }
                } else if (rangeWhich2) {
                  if (this.allProducts[productListIindex].qty_range_2_per > 0) {
                    productPrice =
                      productPrice -
                      (productPrice *
                        this.allProducts[productListIindex].qty_range_2_per) /
                        100;
                  }
                } else if (rangeWhich3) {
                  if (this.allProducts[productListIindex].qty_range_3_per > 0) {
                    productPrice =
                      productPrice -
                      (productPrice *
                        this.allProducts[productListIindex].qty_range_3_per) /
                        100;
                  }
                }
              }
              
            } else {
              if (this.cartItems[index].purchaseType == 1) {
                productPrice = this.allProducts[productListIindex].sale_price;
              } else if (
                this.cartItems[index].purchaseType == 2
              ) {
                productPrice =
                  this.allProducts[productListIindex].autoship_price_customer;
              } else {
                productPrice = this.allProducts[productListIindex].sale_price;
              }
              console.log("price before discount ",productPrice)
              if (this.cartItems[index].purchaseType != 2 && this.couponCodeData.discount_type !== 'buy_x_get_y') {

                if (customerRangeWhich1) {
              if (
                this.allProducts[productListIindex].cust_qty_range_1_per > 0
              ) {
                productPrice =
                  productPrice -
                  ((productPrice *
                    this.allProducts[productListIindex].cust_qty_range_1_per) /
                    100).toFixed(2);
              }
            } else if (customerRangeWhich2) {
              if (
                this.allProducts[productListIindex].cust_qty_range_2_per > 0
              ) {
                productPrice =
                  productPrice -
                  ((productPrice *
                    this.allProducts[productListIindex].cust_qty_range_2_per) /
                    100).toFixed(2);;
              }
            } else if (customerRangeWhich3) {
              if (
                this.allProducts[productListIindex].cust_qty_range_3_per > 0
              ) {
                productPrice =
                  productPrice -
                  ((productPrice *
                    this.allProducts[productListIindex].cust_qty_range_3_per) /
                    100).toFixed(2);;
              }
            }

              }

              
            }

            //let productImage = "";
            // if (productSingle.value.images_url.length > 0) {
            //   productImage = productSingle.value.images_url[0];
            // }
          } else {
            if (this.cartItems[index].purchaseType == 1) {
              productPrice = this.allProducts[productListIindex].sale_price;
            } else if (this.cartItems[index].purchaseType == 2) {
              productPrice =
                this.allProducts[productListIindex].autoship_price_customer;
            } else {
              productPrice = this.allProducts[productListIindex].sale_price;
            }
          if (this.cartItems[index].purchaseType != 2 && this.couponCodeData.discount_type !== 'buy_x_get_y') {
              if (customerRangeWhich1) {
                if (
                  this.allProducts[productListIindex].cust_qty_range_1_per > 0
                ) {
                  productPrice =
                    productPrice -
                    ((productPrice *
                      this.allProducts[productListIindex].cust_qty_range_1_per) /
                      100).toFixed(2);
                }
              } else if (customerRangeWhich2) {
                if (
                  this.allProducts[productListIindex].cust_qty_range_2_per > 0
                ) {
                  productPrice =
                    productPrice -
                    ((productPrice *
                      this.allProducts[productListIindex].cust_qty_range_2_per) /
                      100).toFixed(2);;
                }
              } else if (customerRangeWhich3) {
                if (
                  this.allProducts[productListIindex].cust_qty_range_3_per > 0
                ) {
                  productPrice =
                    productPrice -
                    ((productPrice *
                      this.allProducts[productListIindex].cust_qty_range_3_per) /
                      100).toFixed(2);;
                }
              }

            }
          }

          console.log("productPrice ", productPrice);
          this.cartItems[index].price = productPrice;

          // New code Ends here
        } else {
          swal({
            position: "top-end",
            icon: "error",
            title: "Quantity can not be zero.",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      }
    },

    resetAllData() {
      this.cartItems = [];
      this.couponCodeData = {
        codeApplied: false,
        id: null,
        discount_value: null,
        discount_type: null,
        discountCode: null,
      };
      (this.shippingRate = 0),
        (this.tax = {
          isTax: false,
          state_id: null,
          tax_value: null,
        });
      this.allProducts = [];
    },
    removeFromCart(item) {
      console.log("item : ", item);
      // alert("here");
      this.cartItems = this.cartItems.filter(
        (product) => product.id !== item.id
      );
      if (this.cartItems.length == 0) {
        this.resetAllData();
      }
      swal({
        position: "top-end",
        icon: "success",
        title: "Your item has been removed",
        showConfirmButton: false,
        timer: 1500,
      });
    },
  },
});
